module.exports = __webpack_public_path__ + "static/img/price-form.098447e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/price-form.png
// module id = Shwd
// module chunks = 1